import { render, staticRenderFns } from "./SpecimenPhoto.vue?vue&type=template&id=6a9d148a"
import script from "./SpecimenPhoto.vue?vue&type=script&lang=js"
export * from "./SpecimenPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports